import { render, staticRenderFns } from "./AuthorInfo.vue?vue&type=template&id=8965e566&scoped=true"
import script from "./AuthorInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthorInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AuthorInfo.vue?vue&type=style&index=0&id=8965e566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8965e566",
  null
  
)

export default component.exports